export default "__VITE_ASSET__CXByakE1__"